module.exports = __webpack_public_path__ + "epdf-app/dashboard/folder-route-2dxNBOh2.html";